import { Text } from "@mantine/core"
import { useSuspenseQueryGet } from "@/typed-client/hooks/use-suspense-query-get"
import { t } from "i18next"

export function ProductionTitle({
  productionId,
  onTitleChange,
}: {
  productionId: number
  onTitleChange?: (title: string) => void
}) {
  const { data: production } = useSuspenseQueryGet(
    "/api/Production/GetDetails",
    { productionId }
  )
  const title = production
    ? production.title || `Produktion #${productionId}`
    : t("DeletedOrNoPermission")
  React.useEffect(() => {
    onTitleChange?.(title)
  }, [title, onTitleChange])
  if (!production) {
    return (
      <Text span inherit>
        {title}
      </Text>
    )
  }
  return (
    <Text span inherit>
      {title}
    </Text>
  )
}
